import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'page-not-allowed',
  templateUrl: './page-not-allowed.component.html',
  styleUrls: ['./page-not-allowed.component.scss'],
  standalone: true,
  imports: [TranslocoPipe, MatIconModule, IconDirective, RouterLink],
})
export class PageNotAllowedComponent {
  error: string;
  route = inject(ActivatedRoute);

  constructor() {
    this.error = this.route.snapshot.queryParamMap.get('error');
  }
}
